module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmSU5fCxc4EsA.484cddf4.woff2";